// extracted by mini-css-extract-plugin
export default {"root":"ImageGenModelSelect_root__bJ5L+","label":"ImageGenModelSelect_label__JsVzt","title":"ImageGenModelSelect_title__c7mts"};